import { render, staticRenderFns } from "./snailBookListDetail.vue?vue&type=template&id=5bfa6fda&scoped=true&"
import script from "./snailBookListDetail.vue?vue&type=script&lang=js&"
export * from "./snailBookListDetail.vue?vue&type=script&lang=js&"
import style0 from "./snailBookListDetail.vue?vue&type=style&index=0&id=5bfa6fda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfa6fda",
  null
  
)

export default component.exports